export let resume = {
  education: [
    {
      timeline: "August 2018 - May 2021",
      title: "Master of Computer Applications (MCA)",
      description: "",
      place: "Aurora's PG College, Telangana",
    },
    {
      timeline: "June 2015 - July 2018",
      title: "Bachelor of Science (MECs)",
      description: "",
      place: "Wesley Degree College, Secundrabad",
    },
  ],
  experience: [
    {
      timeline: "Dec 2021 - Present",
      title: "Sr. Android Developer",
      description: "",
      place: "Quin Design",
    },
    {
      timeline: "May 2021 - Dec 2021",
      title: "Android Developer",
      description: "",
      place: "Yamizo pvt ltd.",
    },
  ],
};
